import apiService from "./ApiService"
import { createQS } from "./Utils"

export const veiculosMock = [
    { id: 1, marca: 'VW', modelo: 'Gol', placa: 'ABC-1234', ano: 2020 },
    { id: 2, marca: 'Ford', modelo: 'Fiesta', placa: 'DEF-5678', ano: 2019 },
    { id: 3, marca: 'Chevrolet', modelo: 'Onix', placa: 'GHI-9012', ano: 2021 },
]

class VeiculoService {
  async get(termo, idEmpresa, pagina) {
    try {
      const qs = createQS({ termo, idEmpresa, pagina })
      return await apiService.get('veiculo?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('veiculo/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('veiculo', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async update(id, data) {
    try {
      return await apiService.put('veiculo/' + id, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('veiculo/' + id)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }  
}

const veiculoService = new VeiculoService()
export default veiculoService